import { render, staticRenderFns } from "./cyManufacturer.vue?vue&type=template&id=8ccac7d8"
import script from "./cyManufacturer.vue?vue&type=script&lang=js"
export * from "./cyManufacturer.vue?vue&type=script&lang=js"
import style0 from "./cyManufacturer.vue?vue&type=style&index=0&id=8ccac7d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports